export type AsyncUiOptions<T> = {
    action: () => Promise<T>;
    setLoading: (value: boolean) => void;
    setError: (value: string | null) => void;
    onSuccess?: (result: T) => void;
};

export const runAsyncUi = async <T>({
    action,
    setLoading,
    setError,
    onSuccess,
}: AsyncUiOptions<T>): Promise<T | null> => {
    setLoading(true);
    setError(null);

    try {
        const result = await action();
        onSuccess?.(result);
        return result;
    } catch (error) {
        if (error instanceof Error) {
            setError(error.message);
        } else {
            setError('Ocurrió un error inesperado.');
        }
        return null;
    } finally {
        setLoading(false);
    }
};
